<template>
  <div>
    <!-- 地图 -->
    <div id="container" ref="container"></div>
  </div>
</template>
<script>

export default {
  name: "baiDu",
  props: {
    defaultData: {
      type: Array,
      default: () => []
    },
    cityName: { // 新增：接收父组件传入的城市名
      type: String,
      default: ''
    }
  },
  data() {
    return {
      BMapGL: null,
      map: null,
    };
  },
  mounted() {
    this.initAMap();
  },
  unmounted() {
    this.map?.destroy();
  },
  watch: {
    cityName(newVal) {
      if (newVal) {
        this.gotoCity(newVal);
      }
    }
  },
  methods: {
    // 初始化地图
    initAMap() {

      this.$nextTick(() => {
        var ak = 'GZQT8L85QtZfRfSYEoW82abcNiaGjKmw'    // 申请的ak 前往百度地图开发平台注册百度账号,申请密钥
        this.loadBMap(ak).then((BMapGL) => {
          this.BMapGL = BMapGL;

          // 创建地图实例 
          this.map = new BMapGL.Map("container");
          // 初始化地图，设置中心点坐标和地图级别 
          this.map.centerAndZoom(new BMapGL.Point(116.404, 39.915), 15);
          //开启鼠标滚轮缩放
          this.map.enableScrollWheelZoom(true);     
          // 添加比例尺控件
          this.map.addControl(new BMapGL.ScaleControl());
          // 添加缩放控件
          this.map.addControl(new BMapGL.ZoomControl());

          this.addOverlay(this.defaultData)
        })
      })
    },
    clearMap() {
      if(this.map) {
        this.map.clearOverlays();
      }
    },
    // 添加图层
    addOverlay(array) {
      this.clearMap()
      for (const item of array) {
        this.addPosition(item)
      }
    },
    // 删除图层
    removeOverlay(array) {
      var allOverlay = this.map.getOverlays();
      allOverlay.map(overlay => {
        array.forEach(function (item, index) {
          console.log(index)
          if (overlay.content == item[2] || overlay.contentText == item[2]) {
            overlay.hide()
            this.map.removeOverlay(overlay);
          }
        })
      })
    },
    // 添加坐标点
    addPosition(item) {
      if(!this.BMapGL) {
        console.error("this.BMapGL 为空", this.BMapGL)
        return
      }
      const point = new this.BMapGL.Marker(new this.BMapGL.Point(item[0], item[1]))
      point.contentText = item[2]
      this.map.addOverlay(point);

      var opts = {
        position: new this.BMapGL.Point(item[0], item[1]), // 指定文本标注所在的地理位置
        offset: new this.BMapGL.Size(12, -30) // 设置文本偏移量
      };
      // 创建文本标注对象
      var label = new this.BMapGL.Label(item[2], opts);
      // 自定义文本标注样式
      label.setStyle({
        color: item[3],
        borderRadius: '5px',
        borderColor: '#ccc',
        padding: '10px',
        fontSize: '13px',
        height: '20px',
        lineHeight: '20px',
        fontFamil: '微软雅黑'
      });
      this.map.addOverlay(label);
    },
    loadBMap(akValue) {
      return new Promise(function (resolve, reject) {
        if (typeof window.BMapGL !== "undefined") {
          resolve(window.BMapGL);
          return true;
        }

        // 百度地图异步加载回调处理，不使用加载的script不会执行
        window.onBMapCallback = function () {
          console.log("百度地图脚本初始化成功...");
          resolve(window.BMapGL);
        };

        let script = document.createElement("script");
        script.type = "text/javascript";
        script.src = `https://api.map.baidu.com/api?type=webgl&v=1.0&ak=${akValue}&callback=onBMapCallback`;
        // 启用 https 配置，通过 s=1 参数实现
        // 启用 callback 参数，异步加载必须使用此参数才可以生效
        script.onerror = reject;
        document.documentElement.appendChild(script);
      })
    },
    // methods 中新增
    gotoCity(cityName) {
      if (!this.BMapGL || !this.map) {
        console.warn('地图未初始化，无法跳转城市');
        return;
      }

      const geocoder = new this.BMapGL.Geocoder();
      geocoder.getPoint(cityName, (point) => {
        if (point) {
          // 移动地图到该点，缩放级别设为 12（可根据需要调整）
          this.map.centerAndZoom(point, 12);
        } else {
          this.$message?.error?.(`无法定位城市: ${cityName}`) || 
            console.error(`无法定位城市: ${cityName}`);
        }
      });
    },
  },
};
</script>
<style scoped>
#container {
  width: 100%;
  height: 800px;
}
</style>